// src/index.js
import React from "react";
import ReactDOM from "react-dom/client"; // Use 'react-dom/client' for React 18
import { Provider as ReduxProvider } from "react-redux";
import { QueryClientProvider } from "react-query";
import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";
import store from "./redux/store";
import queryClient from "./queryClient";
import { GlobalStyles } from "@mui/material";
import App from "./App";
import ErrorBoundary from "./components/common/ErrorBoundary";
import "./App.css";
import { ScaleProvider } from "./ScaleContext";
import { createScaledTheme } from "./theme";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ErrorBoundary>
    <ReduxProvider store={store}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={createScaledTheme}>
          <GlobalStyles
            styles={{
              "*": {
                scrollbarWidth: "thin",
                scrollbarColor: "#b0b8c6 #e0e0e0",
              },
              "*::-webkit-scrollbar": {
                width: "12px",
              },
              "*::-webkit-scrollbar-track": {
                background: "#e0e0e0",
                borderRadius: "10px",
                boxShadow: "inset 5px 5px 10px #bebebe, inset -5px -5px 10px #ffffff",
              },
              "*::-webkit-scrollbar-thumb": {
                background: "#b0b8c6",
                borderRadius: "10px",
                boxShadow: "inset 2px 2px 5px #ffffff, inset -2px -2px 5px #a3a3a3",
              },
            }}
          />
          <BrowserRouter>
            <ScaleProvider>
              <App />
            </ScaleProvider>
          </BrowserRouter>
        </ThemeProvider>
      </QueryClientProvider>
    </ReduxProvider>
  </ErrorBoundary>
);
